import { ButtonTypes, LinkTypes, SimplifiedIcons } from '@cox/core-ui8/dist/Button'

import ReactButton, { ReactButtonProps } from '../../../ReactButton'
import { Dropdown } from '../../../shared/ReactBootstrap'
import { addressFormat } from '../../AddressCapture/types'

const MultipleAddressDropdown = (props: any): JSX.Element => {
  const {
    addressList,
    selectedAddress,
    configuredFor,
    multipleAddressChevron,
    multipleAddressChevronAlt,
    handleSelect,
    onSubmit
  } = props

  let primaryButtonText = 'Check availability'

  if (configuredFor === 'outagemap') {
    primaryButtonText = 'Search'
  }

  const checkAvilabilitynProps: ReactButtonProps = {
    buttonTypes: ButtonTypes.PRIMARY,
    id: 'test-primary-button',
    isInEditor: false,
    linkType: LinkTypes.PAGE,
    linkUrl: '',
    text: primaryButtonText,
    simplified: SimplifiedIcons.CHEVRON
  }

  return (
    <div className='react-ac-multiple-container form-basic-dropdown'>
      <div className='react-ac-multiple-dropdown'>
        <Dropdown>
          <Dropdown.Toggle variant='ghost' id='dropdown-basic' className={`input responsive-size`}>
            <div className='react-ac-multiple-selected'>
              {selectedAddress
                ? selectedAddress?.address +
                  ', ' +
                  (selectedAddress?.apt ? selectedAddress?.apt + ', ' : '') +
                  selectedAddress?.zipCode
                : 'Select address'}
            </div>
            <div className={'icon'}>
              <img src={multipleAddressChevron} alt={multipleAddressChevronAlt} />
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {addressList &&
              addressList?.length > 0 &&
              addressList?.map(
                ({
                  address = '',
                  apt = '',
                  zipCode = '',
                  houseNumber = '',
                  serviceabilityType = '',
                  city = '',
                  state = '',
                  unitType = ''
                }: addressFormat) => {
                  return (
                    <Dropdown.Item
                      key={houseNumber}
                      eventKey={houseNumber}
                      onClick={() =>
                        handleSelect(address, apt, zipCode, serviceabilityType, city, state, houseNumber, unitType)
                      }
                    >
                      {address + ', ' + (apt ? apt + ', ' : '') + zipCode}
                    </Dropdown.Item>
                  )
                }
              )}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className='react-ac-multiple-button'>
        <ReactButton {...checkAvilabilitynProps} simplified={undefined} customClickEvent={onSubmit}></ReactButton>
      </div>
    </div>
  )
}

export default MultipleAddressDropdown
